// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";

export const filtersOpenedSelector = (state: ApplicationState) => {
    // console.log(toToolkitApplicationState(state), "toToolkitApplicationState(state)");
    return toToolkitApplicationState(state).bunzl.pages.reportOrderFrequency.filtersOpen;
};
export const locationsSelector = (state: ApplicationState) => {
    // console.log(toToolkitApplicationState(state), "toToolkitApplicationState(state)");
    return toToolkitApplicationState(state).bunzl.pages.reportOrderFrequency.locationList;
};
export const reportOrderFrequencySelector = (state: ApplicationState) => {
    // console.log(toToolkitApplicationState(state), "toToolkitApplicationState(state)");
    return toToolkitApplicationState(state).bunzl.pages.reportOrderFrequency.orderFrequencyReportData;
};
export const reportParametersSelector = (state: ApplicationState) => {
    // console.log(toToolkitApplicationState(state), "toToolkitApplicationState(state)");
    return toToolkitApplicationState(state).bunzl.pages.reportOrderFrequency.getReportParams;
};
